import React from 'react';

// functions
import { decimalOrBust } from '../../utilities/currency';
import { resize } from '../../services/cloudinaryService';
import { config } from '../../config/';
import Cookie from 'js-cookie';

function selectAndFormatRange(range = '', name = '') {
  const retVal = range || name;
  return retVal[0] ? `${retVal[0].toUpperCase()}${retVal.slice(1).toLowerCase()}` : '';
}

function selectAndFormatDescription(webDescription = '') {
  return webDescription || '';
}

function selectAndFormatSwatch(swatchColour = '') {
  return swatchColour ? `in ${swatchColour.toLowerCase()}` : '';
}

function formatPrice(price) {
  return `£${decimalOrBust(price)}`;
}

function BundleBasketItem({ item }) {
	const isDiscounted = item.totalPrice.value !== item.wasPrice.value;
	
  return [
    <div
      key={`bundle-${item.entryNumber}-desc`}
      className="u-padding-y-small u-padding-left-small basket__item__description">
      <div className="basket__item__range">{selectAndFormatRange(item.range, item.name)} bundle</div>
      <div className="basket__item__swatch"><small>{selectAndFormatSwatch(item.swatchColour)}</small></div>
    </div>,
	  item.product.productReferences.map((ref, i) => function () {
		  const sofologistCookie = Cookie.getJSON('mySofologySofologist');
		  const rangeLink = `${config.URLS.SOFOLOGY_HOME}/sofas/${ref.target.range}?code=${ref.target.code}` 
		  return (<li
			  key={`bundle-${item.entryNumber}-item-${ref.target.code}`}
			  className={i + 1 !== item.product.productReferences.length ? 'no-border' : 'u-padding-bottom-small'}
		  >
			  <div
				  className="basket__bundle-item u-padding-top-small u-padding-bottom-small"
			  >
				  <div className="image-wrap">
					  {rangeLink !== '' && sofologistCookie == null ? (
						  <a href={rangeLink}>
							  <img src={resize(ref.target.scoopImage)} alt={''} />
						  </a>
					  ) : <img src={resize(ref.target.scoopImage)} alt={''} />
					  }
					  {ref.quantity > 1 ? (
						  <span className="quantity">
							  x{ref.quantity}
						  </span>
					  ) : null
					  }
				  </div>

				  <div className="description u-padding-left-small">
					  <div className="range">{selectAndFormatRange(ref.target.range, ref.target.name)}</div>
					  <div className="web-description">{selectAndFormatDescription(ref.target.webDescription)}</div>
					  <div className="swatch">{selectAndFormatSwatch(ref.target.swatchColour)}</div>
				  </div>
			  </div>

		  </li>
		  )
	  }    
    ),
    (
      <li
        key={`bundle-${item.entryNumber}-price`}
      >
        <div
          className="basket__item basket__item__bundle-total u-padding-top-small u-padding-bottom-small u-padding-right-small"
        >
          <div className="description ">
            <div className="range u-text-nowrap">Bundle total</div>
          </div>
        </div>

        <div className="basket__value u-padding-small u-padding-top-medium">
          <div>{formatPrice(item.totalPrice.value)}</div>
          {
            isDiscounted ? (
              <div><strike>{formatPrice(item.wasPrice.value)}</strike></div>
            ) : null
          }
        </div>
      </li>
    )
  ];
}

export default BundleBasketItem;



// WEBPACK FOOTER //
// ./src/parts/HybrisBasket/BundleBasketItem.js